export default "__VITE_PUBLIC_ASSET__3dc52de1__"